export default __webpack_public_path__ + "static/media/calendar.583b580c.png";